import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";

export const useStyles = makeStyles((theme: Theme) => ({
  belowNormalInput: {
    borderRadius: "4px",
    width: "20px",
    height: "20px",
    margin: theme.spacing(1.5, 1, 1, 3.6),
  },
  checkLabel: {
    fontWeight: 400,
    color: theme.palette.UI.grey_700,
    fontSize: "14px",
  },
  dialog: {
    margin: 0,
    padding: theme.spacing(1.5, 1.5, 1, 1.5),
  },
  dialogCloseButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.UI.grey_500,
  },

  appBar: { position: "inherit" },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  badge: {
    fontWeight: 600,
    height: 16,
    minWidth: 16,
  },
  addButton: {
    height: "36px",
    padding: "6px 14px 6px 14px",
    minWidth: "100px",
    marginRight: theme.spacing(1),
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "600 !important",
  },
  cancelButton: {
    padding: "6px, 14px, 6px, 14px",
    minWidth: "58px",
    marginRight: theme.spacing(1),
    textTransform: "none",
    fontSize: "14px",
    height: "36px",
  },
  popheading: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px !important",
    fontWeight: "bold!important",
    minWidth: 300,
    color: theme.palette.UI.black,
    paddingTop: "2px"
  },
  smallDialogPaper: {
    overflowY: "hidden",
  },
  loginLoader: {
    color: "primary",
  },
  deleteIcon: {
    "& svg path": {
      fill: theme.palette.UI.purple_700,
    },
  },
  delete: {
    color: theme.palette.UI.purple_700,
  },
  closeIcon: {
    padding: 4,
    "& svg path": {
      fill: theme.palette.UI.grey_700,
    },
  },
  paper: {
    minHeight: "80vh"
  },
  applicationBoxes: {
    minHeight: 180,
    cursor: "pointer",
  },
  applicationCardContent: {
    color: theme.palette.UI.grey_800,
    fontSize: "13px !important",
  }
}));
